import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrGetItrDetailsInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-file', title: 'ITR Get ITR Details', subtitle: 'Fetch Income Tax Return details for an ITR client' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true },
            { name: 'itr_id', label: 'ITR ID', icon: 'pi-hashtag', placeholder: 'ITR request ID', maxLength: 100, mono: true },
        ]}
        endpoint={{
            method: 'GET',
            path: '/surepass/itr/get-itr-details',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), itr_id: v.itr_id.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-get-itr-details"
        submitLabel="Fetch ITR Details"
        successSummary="ITR details fetched"
        errorSummary="ITR fetch failed"
        confirmHeader="Confirm ITR details fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR Details', icon: 'pi-file' }}
    />
);

export default ItrGetItrDetailsInputComponent;
